import { IconLib } from '@fold-dev/core'
import { View, Link } from '@fold-dev/core'
import React from 'react'

export const IconPanel = ({ icons, icon, onChange }) => {
    return (
        <View p="1rem">
            <View
                row
                width="100%"
                wrap="wrap"
                justifyContent="flex-start"
                gap={5}>
                {icons.map((i, index) => {
                    return (
                        <View
                            row
                            key={index}
                            onClick={() => onChange(i)}
                            className="f-buttonize"
                            colorToken={icon == i ? 'text' : 'text-weakest'}>
                            <IconLib icon={i} />
                        </View>
                    )
                })}
            </View>

            {!!icon && (
                <Link
                    m="1rem 0 0 0"
                    display="inline-block"
                    size="sm"
                    className="f-underline"
                    onClick={() => {
                        onChange('')
                    }}>
                    Clear icon
                </Link>
            )}
        </View>
    )
}
